import React from "react";

const PauseIcon = () => {
  return (
    <svg
      className=" cursor-pointer w-7 h-7 shrink-0 "
      id="start"
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="36"
      viewBox="0 0 31 36"
    >
      <g id="Rectangle_42" fill="none" stroke="#000" strokeWidth="2">
        <rect width="12" height="36" rx="3" stroke="none" />
        <rect x="1" y="1" width="10" height="34" rx="2" fill="none" />
      </g>
      <g
        id="Rectangle_43"
        transform="translate(19)"
        fill="none"
        stroke="#000"
        strokeWidth="2"
      >
        <rect width="12" height="36" rx="3" stroke="none" />
        <rect x="1" y="1" width="10" height="34" rx="2" fill="none" />
      </g>
    </svg>
  );
};

export default PauseIcon;
